import router from './router'
import store from './store'
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css'// Progress 进度条样式
import { Message } from 'element-ui'
import { getToken } from '@/utils/auth' // 验权

const whiteList = ['/login','/register'] // 不重定向白名单
router.beforeEach((to, from, next) => {
  NProgress.start()
  if (getToken()) {
    if (to.path === '/login') {
      next({ path: '/' })
      NProgress.done() // if current page is dashboard will not trigger	afterEach hook, so manually handle it
    } else {
      if (store.getters.roles.length === 0) {
        store.dispatch('GetInfo').then(res => { // 拉取用户信息
          // let menus=res.data.menus;
          let menus=[
            {
              createTime: "2023-07-25 19:18:43",
              hidden: 0,
              icon: "sourcems-manage",
              id: 1,
              level: 0,
              name: "managems",
              parentId: 0,
              sort: 0,
              title: "教学管理系统",
            },
            {
              createTime: "2023-07-25 19:18:43",
              hidden: 0,
              icon: "user",
              id: 2,
              level: 0,
              name: "studentFile",
              parentId: 1,
              sort: 0,
              title: "学生档案管理",
            },
            {
              createTime: "2023-07-25 19:18:43",
              hidden: 1,
              icon: "ums",
              id: 4,
              level: 0,
              name: "studentFileAdd",
              parentId: 1,
              sort: 0,
              title: "学生档案信息",
            },
            {
              createTime: "2023-07-25 19:18:43",
              hidden: 1,
              icon: "ums",
              id: 24,
              level: 0,
              name: "studentWorkList",
              parentId: 1,
              sort: 0,
              title: "学生作品",
            },
            {
              createTime: "2023-07-25 19:18:43",
              hidden: 0,
              icon: "comment",
              id: 5,
              level: 0,
              name: "commentms",
              parentId: 0,
              sort: 0,
              title: "教学评价系统",
            },
            {
              createTime: "2023-07-25 19:18:43",
              hidden: 0,
              icon: "comment-zonghe",
              id: 6,
              level: 0,
              name: "multipleComment",
              parentId: 4,
              sort: 0,
              title: "综合性评价",
            },
            {
              createTime: "2023-07-25 19:18:43",
              hidden: 0,
              icon: "comment-score",
              id: 7,
              level: 0,
              name: "scoreComment",
              parentId: 4,
              sort: 0,
              title: "诊断性评价",
            },
            {
              createTime: "2023-07-25 19:18:43",
              hidden: 0,
              icon: "comment-guocheng",
              id: 8,
              level: 0,
              name: "processComment",
              parentId: 4,
              sort: 0,
              title: "过程性评价",
            },
            {
              createTime: "2023-07-25 19:18:43",
              hidden: 0,
              icon: "comment-teacher",
              id: 9,
              level: 0,
              name: "teacherComment",
              parentId: 4,
              sort: 0,
              title: "教师与自我评价",
            },
            {
              createTime: "2023-07-25 19:18:43",
              hidden: 1,
              icon: "ums",
              id: 10,
              level: 0,
              name: "addComment",
              parentId: 4,
              sort: 0,
              title: "学生评价",
            },
            {
              createTime: "2023-07-25 19:18:43",
              hidden: 1,
              icon: "ums",
              id: 11,
              level: 0,
              name: "commentDetail",
              parentId: 4,
              sort: 0,
              title: "评价详情",
            },
            {
              createTime: "2023-07-25 19:18:43",
              hidden: 0,
              icon: "school",
              id: 12,
              level: 0,
              name: "schoolBasems",
              parentId: 0,
              sort: 0,
              title: "校本课程系统",
            },
            {
              createTime: "2023-07-25 19:18:43",
              hidden: 0,
              icon: "school-base",
              id: 13,
              level: 0,
              name: "classList",
              parentId: 11,
              sort: 0,
              title: "校本课程系统",
            },
            {
              createTime: "2023-07-25 19:18:43",
              hidden: 0,
              icon: "teacher-list",
              id: 14,
              level: 0,
              name: "teacherClass",
              parentId: 11,
              sort: 0,
              title: "老师课程记录",
            },
            {
              createTime: "2023-07-25 19:18:43",
              hidden: 1,
              icon: "ums",
              id: 15,
              level: 0,
              name: "uploadPreparations",
              parentId: 11,
              sort: 0,
              title: "上传课件",
            },
            {
              createTime: "2023-07-25 19:18:43",
              hidden: 1,
              icon: "ums",
              id: 22,
              level: 0,
              name: "classDetail",
              parentId: 11,
              sort: 0,
              title: "课程详情",
            },
            {
              createTime: "2023-07-25 19:18:43",
              hidden: 1,
              icon: "ums",
              id: 23,
              level: 0,
              name: "courseWareAdd",
              parentId: 11,
              sort: 0,
              title: "课件管理",
            },
            {
              createTime: "2023-07-25 19:18:43",
              hidden: 0,
              icon: "preapre",
              id: 16,
              level: 0,
              name: "preparationms",
              parentId: 0,
              sort: 0,
              title: "教师备课系统",
            },
            // {
            //   createTime: "2023-07-25 19:18:43",
            //   hidden: 0,
            //   icon: "ums",
            //   id: 17,
            //   level: 0,
            //   name: "collectClassList",
            //   parentId: 16,
            //   sort: 0,
            //   title: "我的收藏",
            // },
            {
              createTime: "2023-07-25 19:18:43",
              hidden: 0,
              icon: "duihuan",
              id: 18,
              level: 0,
              name: "classExchange",
              parentId: 16,
              sort: 0,
              title: "课程兑换记录",
            },
            {
              createTime: "2023-07-25 19:18:43",
              hidden: 0,
              icon: "record-zs",
              id: 18,
              level: 0,
              name: "intergral",
              parentId: 16,
              sort: 0,
              title: "钻石记录",
            },
            {
              createTime: "2023-07-25 19:18:43",
              hidden: 0,
              icon: "sourcems",
              id: 19,
              level: 0,
              name: "sourceClass",
              parentId: 0,
              sort: 0,
              title: "教学资源系统",
            },
            {
              createTime: "2023-07-25 19:18:43",
              hidden: 0,
              icon: "sourcems-list",
              id: 20,
              level: 0,
              name: "sourceList",
              parentId: 19,
              sort: 0,
              title: "教学资源列表",
            },
            {
              createTime: "2023-07-25 19:18:43",
              hidden: 1,
              icon: "ums",
              id: 21,
              level: 0,
              name: "sourceDetail",
              parentId: 19,
              sort: 0,
              title: "教学资源详情",
            },
            {
              createTime: "2023-07-25 19:18:43",
              hidden: 0,
              icon: "ums",
              id: 25,
              level: 0,
              name: "aihelp",
              parentId: 0,
              sort: 0,
              title: "AI辅助",
            },
            {
              createTime: "2023-07-25 19:18:43",
              hidden: 0,
              icon: "ai",
              id: 26,
              level: 1,
              name: "aihelpAll",
              parentId: 25,
              sort: 0,
              title: "AI辅助",
            },
             {
              createTime: "2023-07-25 19:18:43",
              hidden: 0,
              icon: "table",
              id: 27,
              level: 0,
              name: "teachTools",
              parentId: 0,
              sort: 0,
              title: "教学辅助工具",
            },
             {
              createTime: "2023-07-25 19:18:43",
              hidden: 0,
              icon: "marker",
              id: 28,
              level: 0,
              name: "timeTool",
              parentId: 26,
              sort: 0,
              title: "教学辅助工具",
            },
             {
              createTime: "2023-07-25 19:18:43",
              hidden: 0,
              icon: "marker",
              id: 29,
              level: 0,
              name: "liveStreams",
              parentId: 0,
              sort: 0,
              title: "电商直播模拟系统",
            },
             {
              createTime: "2023-07-25 19:18:43",
              hidden: 0,
              icon: "marker",
              id: 30,
              level: 0,
              name: "liveStream",
              parentId: 29,
              sort: 0,
              title: "电商操作系统",
            },
          ]
          let username=res.data.username;
          store.dispatch('GenerateRoutes', { menus,username }).then(() => { // 生成可访问的路由表
            router.addRoutes(store.getters.addRouters); // 动态添加可访问路由表
            next({ ...to, replace: true })
          })
        }).catch((err) => {
          store.dispatch('FedLogOut').then(() => {
            Message.error(err || 'Verification failed, please login again')
            next({ path: '/' })
          })
        })
      } else {
        next()
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next('/login')
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done() // 结束Progress
})



// WEBPACK FOOTER //
// ./src/permission.js